import z from 'zod';

export enum SeedQuestionSource {
  OAK = 'OAK',
  GPT = 'GPT',
  MANUAL = 'MANUAL',
}

export const seedQuestionSourceSchema = z.nativeEnum(SeedQuestionSource);
